import { selectors } from './initialization.js';

/**
 * Custom handlebars helper functions
 *
 * @link https://handlebarsjs.com/guide/
 */
const isHelpcenterUrl = (url) => url.includes('help.meisterplan.com');
const isTypeDocument = (type) => type === 'pdf';
const extractFilename = (file) => {
	const lastIndex = file.lastIndexOf('/');
	return file.substring(lastIndex + 1, file.indexOf('.pdf'));
};

const isDifferentHost = (url) => {
	try {
		// Create a new URL object from the input URL
		const inputUrl = new URL(url);

		// Get the current page's host
		const currentHost = window.location.host;

		// Compare the hosts
		return currentHost !== inputUrl.host;
	} catch (error) {
		// Handle invalid URL error
		console.error('Invalid URL:', error);
		return false;
	}
};

export const mpRegisterHandlebarsHelper = (searchEl, searchUI) => {
	searchUI.registerHandlebarsHelper('getSuggestionHTML', (value) => {
		const input = searchEl.querySelector(selectors.searchInput).value.toLowerCase();
		const split = value.split(input);
		return `${input}<span>${split[1]}</span>`;
	});

	searchUI.registerHandlebarsHelper('getMetaDescription', (string) => {
		const input = searchEl.querySelector(selectors.searchInput).value.toLowerCase();

		// If meta description is given and search term is longer than 3 characters
		// Split search term into multiple words and highlight occurences
		if (string && input.length >= 3) {
			const singleWords = input.split(' ');
			const re = singleWords.join('|');
			const regexp = new RegExp(`(${re})`, 'gmi');
			string = string.replace(regexp, '<em>$1</em>');
		}
		return string;
	});

	searchUI.registerHandlebarsHelper('isTypeDocument', isTypeDocument);
	searchUI.registerHandlebarsHelper('extractFilename', extractFilename);
	searchUI.registerHandlebarsHelper('isHelpcenterUrl', isHelpcenterUrl);
	searchUI.registerHandlebarsHelper('openInNewTab', (url, documentType) => isDifferentHost(url) || isTypeDocument(documentType));
};
